/**
 * AppointmentWarningModal - Warning shown when taking a ticket with a pending appointment
 */

import { AlertCircle } from 'lucide-react';

interface AppointmentWarningModalProps {
  onCancel: () => void;
  onContinue: () => void;
}

export function AppointmentWarningModal({ onCancel, onContinue }: AppointmentWarningModalProps) {
  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
      <div className="bg-surface border border-hairline rounded-2xl max-w-md w-full p-6">
        <div className="flex items-center gap-3 mb-4">
          <AlertCircle className="w-6 h-6 text-warning shrink-0" aria-hidden="true" />
          <h3 className="font-sans text-lg font-semibold text-ink">
            Tienes una cita pendiente
          </h3>
        </div>

        <p className="text-sm text-ink-muted mb-4">
          Ya tienes una cita agendada para otro día. ¿Estás seguro que quieres sacar un turno adicional?
        </p>

        <div className="bg-warning/10 border border-warning/30 rounded-lg p-3 mb-4">
          <p className="text-sm text-ink">
            Si sacas un turno ahora, mantén tu cita activa o cancélala si ya no la necesitas.
          </p>
        </div>

        <div className="flex gap-3">
          <button
            onClick={onCancel}
            className="flex-1 px-4 py-2 bg-surface-2 border border-hairline text-ink rounded-lg hover:bg-surface-3 font-medium transition-colors"
          >
            Cancelar
          </button>
          <button
            onClick={onContinue}
            className="flex-1 px-4 py-2 bg-accent text-on-accent rounded-lg hover:bg-accent-hover font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-focus"
          >
            Continuar
          </button>
        </div>
      </div>
    </div>
  );
}
